
// html2canvas-pro: fork support oklch() và modern CSS colors (html2canvas v1 fail)
import html2canvas from 'html2canvas-pro';

window.saveDom = html2canvas;

// Tab switching cho popup_getlist (.tabs button[data-tab]) — toggle tương ứng .quest-list-{tab}
document.addEventListener('click', function (e) {
  const tab = e.target.closest && e.target.closest('.popup_getlist .tabs .tab');
  if (!tab) return;
  const popup = tab.closest('.popup_getlist');
  const target = tab.dataset.tab;
  popup.querySelectorAll('.tabs .tab').forEach(function (t) { t.classList.remove('active'); });
  tab.classList.add('active');
  popup.querySelectorAll('.quest-list').forEach(function (list) { list.classList.remove('active'); });
  const panel = popup.querySelector('.quest-list-' + target);
  if (panel) panel.classList.add('active');
});

// Tab switching cho popup_paper_view (.tab-couple / .tab-alone) — toggle cert variant
document.addEventListener('click', function (e) {
  const tab = e.target.closest && e.target.closest('.popup_paper_view .tabs .tab');
  if (!tab) return;
  const popup = tab.closest('.popup_paper_view');
  const target = tab.dataset.tab;     // 'couple' | 'alone'
  popup.querySelectorAll('.tabs .tab').forEach(function (t) { t.classList.remove('active'); });
  tab.classList.add('active');
  popup.querySelectorAll('.cert').forEach(function (c) { c.classList.remove('active'); });
  const cert = popup.querySelector('.cert-' + target);
  if (cert) cert.classList.add('active');
});

// Click "Tạo" trong paper_view → mở paper_create với variant tương ứng tab active
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.popup_paper_view [data-action="create-cert"]');
  if (!btn) return;
  e.preventDefault();
  const view = btn.closest('.popup_paper_view');
  const create = document.querySelector('.popup_paper_create');
  if (!view || !create) return;

  // Đọc tab active hiện tại trong paper_view
  const activeTab = view.querySelector('.tabs .tab.active');
  const variant = activeTab ? activeTab.dataset.tab : 'couple'; // 'couple' | 'alone'

  // Đóng paper_view + mở paper_create với variant đúng
  view.classList.remove('active');
  create.classList.remove('variant-couple', 'variant-alone');
  create.classList.add('variant-' + variant);
  create.classList.add('active');
});

// Click "Trở Lại" trong paper_create → quay về paper_view (giữ tab cũ)
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.popup_paper_create [data-action="back-to-view"]');
  if (!btn) return;
  e.preventDefault();
  const create = btn.closest('.popup_paper_create');
  const view = document.querySelector('.popup_paper_view');
  if (!create || !view) return;
  create.classList.remove('active');
  view.classList.add('active');
});

// Tooltip cho input name1/name2 — tự inject vào .field-input-wrap nếu chưa có
function showTip(input, message) {
  const wrap = input.parentNode;
  if (!wrap) return;
  let tip = wrap.querySelector('.input-tooltip');
  if (!tip) {
    tip = document.createElement('span');
    tip.className = 'input-tooltip';
    wrap.appendChild(tip);
  }
  tip.textContent = message;
  tip.classList.add('show');
}
function hideTip(input) {
  const wrap = input.parentNode;
  if (!wrap) return;
  const tip = wrap.querySelector('.input-tooltip');
  if (tip) tip.classList.remove('show');
}
// Hiện tooltip khi đạt maxlength, ẩn khi xóa bớt
var MAX_NAME_LENGTH = 14;
document.addEventListener('input', function (e) {
  var input = e.target;
  if (!input.matches || !input.matches('#pc-name1, #pc-name2')) return;
  if (input.value.length > MAX_NAME_LENGTH) {
    input.value = input.value.slice(0, MAX_NAME_LENGTH);
  }
  if (input.value.length >= MAX_NAME_LENGTH) {
    showTip(input, 'Tối đa ' + MAX_NAME_LENGTH + ' ký tự');
  } else {
    hideTip(input);
  }
});
// Ẩn tooltip khi blur
document.addEventListener('blur', function (e) {
  const input = e.target;
  if (!input.matches || !input.matches('#pc-name1, #pc-name2')) return;
  hideTip(input);
}, true);

// Submit form trong paper_create → validate rồi mở paper_result với variant + populate names/achievement
document.addEventListener('submit', function (e) {
  const form = e.target.closest && e.target.closest('.popup_paper_create form');
  if (!form) return;
  e.preventDefault();
  const create = form.closest('.popup_paper_create');
  const result = document.querySelector('.popup_paper_result');
  if (!create || !result) return;

  // Đọc variant đang active của paper_create
  const variant = create.classList.contains('variant-alone') ? 'alone' : 'couple';

  // Đọc data từ form
  const data = new FormData(form);
  const name1       = (data.get('name1') || '').toString().trim();
  const name2       = (data.get('name2') || '').toString().trim();
  const achievement = (data.get('achievement') || '').toString().trim();

  // Validate: hiện tooltip và block nếu field bắt buộc bị trống
  let hasError = false;
  const input1 = form.querySelector('#pc-name1');
  const input2 = form.querySelector('#pc-name2');
  if (input1 && !name1) { showTip(input1, 'Vui lòng nhập tên / biệt danh'); hasError = true; }
  if (variant === 'couple' && input2 && !name2) { showTip(input2, 'Vui lòng nhập tên / biệt danh'); hasError = true; }
  if (hasError) return;

  // Populate vào result
  if (variant === 'couple') {
    const n1 = result.querySelector('#result-name-1');
    const n2 = result.querySelector('#result-name-2');
    const ach = result.querySelector('#result-achievement-couple');
    if (n1 && name1) n1.textContent = name1;
    if (n2 && name2) n2.textContent = name2;
    if (ach && achievement) ach.textContent = achievement;
  } else {
    const n  = result.querySelector('#result-name-alone');
    const ach = result.querySelector('#result-achievement-alone');
    if (n && name1) n.textContent = name1;
    if (ach && achievement) ach.textContent = achievement;
  }

  // Đóng create + mở result với variant đúng
  create.classList.remove('active');
  result.classList.remove('variant-couple', 'variant-alone');
  result.classList.add('variant-' + variant);
  result.classList.add('active');
});

// Click "Trở Lại" trong paper_result → quay về paper_create
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.popup_paper_result [data-action="back-to-create"]');
  if (!btn) return;
  e.preventDefault();
  const result = btn.closest('.popup_paper_result');
  const create = document.querySelector('.popup_paper_create');
  if (!result || !create) return;

  // Giữ variant
  const variant = result.classList.contains('variant-alone') ? 'alone' : 'couple';
  result.classList.remove('active');
  create.classList.remove('variant-couple', 'variant-alone');
  create.classList.add('variant-' + variant);
  create.classList.add('active');
});

// Click "Lưu Giấy Chứng Nhận" → populate cert-screenshot-stage (ngoài popup wrapper)
// → html2canvas capture stage đó (pixel-perfect, ko bị transform scale méo).
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.popup_paper_result [data-action="save-cert"]');
  if (!btn) return;
  e.preventDefault();
  console.log('[paper_result] Save cert clicked');

  const result  = btn.closest('.popup_paper_result');
  const variant = result.classList.contains('variant-alone') ? 'alone' : 'couple';
  const stage   = document.getElementById('cert-screenshot-stage');
  if (!stage) {
    console.error('[paper_result] cert-screenshot-stage not found');
    return;
  }
  // Roll 50/50 giữa design v1 (default) và v2 (suffix '2', font RAVIE).
  const lottery = Math.random() < 0.5 ? '' : '2';
  const shot    = stage.querySelector('.cert-shot-' + variant + lottery);
  if (!shot) {
    console.error('[paper_result] No shot for variant', variant + lottery);
    return;
  }
  console.log('[paper_result] Lottery →', variant + (lottery ? ' v2' : ' v1'));

  // Đọc data từ result popup (đã populate khi submit form từ paper_create)
  const resultCert = result.querySelector('.cert-' + variant);
  if (variant === 'couple') {
    const n1  = resultCert.querySelector('#result-name-1');
    const n2  = resultCert.querySelector('#result-name-2');
    const ach = resultCert.querySelector('#result-achievement-couple');
    if (n1)  shot.querySelector('[data-shot="name1"]').textContent      = n1.textContent;
    if (n2)  shot.querySelector('[data-shot="name2"]').textContent      = n2.textContent;
    if (ach) shot.querySelector('[data-shot="achievement-couple"]').textContent = ach.textContent;
  } else {
    const n   = resultCert.querySelector('#result-name-alone');
    const ach = resultCert.querySelector('#result-achievement-alone');
    if (n)   shot.querySelector('[data-shot="name-alone"]').textContent      = n.textContent;
    if (ach) shot.querySelector('[data-shot="achievement-alone"]').textContent = ach.textContent;
  }

  // Show shot variant (CSS .cert-shot.shooting → display:block)
  stage.querySelectorAll('.cert-shot').forEach(function (s) { s.classList.remove('shooting'); });
  shot.classList.add('shooting');

  // Wait fonts + images
  const waitImages = function () {
    const imgs = Array.prototype.slice.call(shot.querySelectorAll('img'));
    return Promise.all(imgs.map(function (img) {
      if (img.complete && img.naturalHeight > 0) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load',  resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    }));
  };

  document.fonts.ready
    .then(waitImages)
    .then(function () {
      console.log('[paper_result] Capturing stage...');
      return html2canvas(shot, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: null,
        scale: 2,
        logging: false,
        width: 638,
        height: 475
      });
    })
    .then(function (canvas) {
      console.log('[paper_result] Captured canvas:', canvas.width, 'x', canvas.height);

      // Filename config: <body data-cert-filename="my-cert-{variant}.png">
      // Hỗ trợ {variant} placeholder. Default: 'giay-chung-nhan-{variant}.png'
      const tpl = document.body.getAttribute('data-cert-filename') || 'giay-chung-nhan-{variant}.png';
      const filename = tpl.replace('{variant}', variant);

      canvas.toBlob(function (blob) {
        if (!blob) {
          console.error('[paper_result] toBlob trả về null');
          return;
        }
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // Cleanup blob URL sau khi download
        setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        console.log('[paper_result] Download triggered');
      }, 'image/png');
    })
    .catch(function (err) {
      console.error('❌ Lỗi khi lưu giấy chứng nhận:', err);
      alert('Không thể lưu giấy chứng nhận: ' + (err && err.message ? err.message : err));
    })
    .then(function () {
      // Hide stage variants
      stage.querySelectorAll('.cert-shot').forEach(function (s) { s.classList.remove('shooting'); });
    });
});

// Tab switching cho popup_rank — chỉ swap active class, list data sẽ load qua JS riêng
document.addEventListener('click', function (e) {
  const tab = e.target.closest && e.target.closest('.popup_rank .tabs .tab');
  if (!tab) return;
  const popup = tab.closest('.popup_rank');
  popup.querySelectorAll('.tabs .tab').forEach(function (t) { t.classList.remove('active'); });
  tab.classList.add('active');
  // Hook để code ngoài subscribe (vd. fetch ranking list theo tab)
  popup.dispatchEvent(new CustomEvent('rank:tabchange', { detail: { tab: tab.dataset.tab } }));
});

// Helper populate quest list từ JS bên ngoài
window.popupGetlistSetQuests = function (tab, items) {
  const list = document.querySelector('.popup_getlist .quest-list-' + tab);
  if (!list) return;
  list.innerHTML = items.map(function (q) {
    const rewards = (q.rewards || []).map(function (r) {
      return '<span class="reward reward-' + r.type + '">' + r.label + '</span>';
    }).join('');
    const btn = q.claimed
      ? '<a href="#" class="btn-claim claimed">Đã Nhận</a>'
      : '<a href="#" class="btn-claim MS__hover">Nhận</a>';
    return '<li class="quest-item">'
      + '<p class="quest-title">' + q.title + '</p>'
      + '<div class="quest-progress">'
      +   '<div class="bar"><span class="fill" style="width:' + (q.percent || 0) + '%"></span></div>'
      +   (q.progress ? '<span class="progress-text">' + q.progress + '</span>' : '')
      + '</div>'
      + '<div class="quest-rewards">' + rewards + '</div>'
      + btn
      + '</li>';
  }).join('');
};

// popup_vote: handlers cho +/- step buttons và quick select 1/5/10/Max
(function () {
  document.addEventListener('click', function (e) {
    // +/- step buttons
    const step = e.target.closest && e.target.closest('.popup_vote .btn-step');
    if (step) {
      e.preventDefault();
      const popup = step.closest('.popup_vote');
      const input = popup.querySelector('.amount-input');
      if (!input) return;
      const delta = parseInt(step.dataset.step, 10) || 0;
      const max = parseInt(input.max, 10) || 999;
      const min = parseInt(input.min, 10) || 1;
      const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + delta));
      input.value = next;
      // Bỏ active của quick buttons
      popup.querySelectorAll('.quick-btn.active').forEach(function (b) { b.classList.remove('active'); });
      return;
    }

    // Quick select 1/5/10/Max
    const quick = e.target.closest && e.target.closest('.popup_vote .quick-btn');
    if (quick) {
      e.preventDefault();
      const popup = quick.closest('.popup_vote');
      const input = popup.querySelector('.amount-input');
      if (!input) return;
      const value = quick.dataset.amount;
      input.value = value === 'max' ? (parseInt(input.max, 10) || 1) : value;
      // Highlight active
      popup.querySelectorAll('.quick-btn.active').forEach(function (b) { b.classList.remove('active'); });
      quick.classList.add('active');
      return;
    }
  });

  // Helper API: đặt số vote hiện có (max) từ ngoài
  window.popupVoteSetMaxVote = function (maxVote) {
    const popup = document.querySelector('.popup_vote');
    if (!popup) return;
    const display = popup.querySelector('.vote-count');
    const input   = popup.querySelector('.amount-input');
    if (display) display.textContent = maxVote;
    if (input)   input.max = maxVote;
  };
})();

// Custom dropdown cho .select-wrap — thay native <select> để fix bug native dropdown
// nhảy sai chỗ khi parent có transform/zoom (mobile).
// API: window.popupSelectSetOptions(name, items) với items=[{value, label}, ...]
(function () {
  document.addEventListener('click', function (e) {
    // Click vào display button → toggle open
    const display = e.target.closest && e.target.closest('.select-wrap .select-display');
    if (display) {
      const wrap = display.closest('.select-wrap');
      // Đóng các select khác
      document.querySelectorAll('.select-wrap.open').forEach(function (w) {
        if (w !== wrap) w.classList.remove('open');
      });
      wrap.classList.toggle('open');
      return;
    }

    // Click vào option → select + close
    const opt = e.target.closest && e.target.closest('.select-wrap .select-options li');
    if (opt) {
      const wrap = opt.closest('.select-wrap');
      const value = opt.dataset.value || '';
      const label = opt.textContent;
      wrap.querySelector('.select-display').textContent = label;
      const hidden = wrap.querySelector('input[type="hidden"]');
      if (hidden) {
        hidden.value = value;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
      wrap.querySelectorAll('li.active').forEach(function (li) { li.classList.remove('active'); });
      opt.classList.add('active');
      wrap.classList.remove('open');
      return;
    }

    // Click ngoài → đóng tất cả
    document.querySelectorAll('.select-wrap.open').forEach(function (w) {
      w.classList.remove('open');
    });
  });

  // Helper để populate options từ JS bên ngoài (vd. fetch API rồi gọi)
  // Hỗ trợ cả native <select> (popup_register) và ul/li (popup_history).
  window.popupSelectSetOptions = function (inputName, items) {
    const selectEl = document.querySelector('.select-wrap select[name="' + inputName + '"]');
    if (selectEl) {
      const wrap = selectEl.closest('.select-wrap');
      const placeholder = wrap ? wrap.getAttribute('data-placeholder') : '';
      const placeholderOpt = placeholder
        ? '<option value="" disabled selected>' + placeholder + '</option>'
        : '';
      selectEl.innerHTML = placeholderOpt + items.map(function (it) {
        return '<option value="' + it.value + '">' + it.label + '</option>';
      }).join('');
      return;
    }
    const hidden = document.querySelector('.select-wrap input[name="' + inputName + '"]');
    if (!hidden) return;
    const ul = hidden.closest('.select-wrap').querySelector('.select-options');
    ul.innerHTML = items.map(function (it) {
      return '<li data-value="' + it.value + '">' + it.label + '</li>';
    }).join('');
  };
})();

function resizeCanvas(canvas, targetW, targetH) {
  const resizedCanvas = document.createElement("canvas");
  resizedCanvas.width = targetW;
  resizedCanvas.height = targetH;
  const ctx = resizedCanvas.getContext("2d");

  ctx.drawImage(canvas, 0, 0, targetW, targetH);
  return resizedCanvas;
}

window.getScreenshotDiv = function () {
  const node = document.getElementById("screenShot");

  if (!node) {
    console.error("❌ Không tìm thấy phần tử #screenShot");
    return;
  }

  
  document.fonts.ready.then(() => {
    html2canvas(node, {
      useCORS: true,
      allowTaint: false,
      backgroundColor: null,
      scale: 2
    }).then(canvas => {
      // Resize về 2000x1000
      $("#screenShot").show();

      const resized = resizeCanvas(canvas, 1500, 530);

      // Dùng JPEG thay vì PNG cho nhẹ
      const dataUrl = resized.toDataURL("image/png", 0.8);

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "sceenShot.jpg"; // đổi tên file .jpg
      link.click();

      $('#screenShot').hide();
      console.log("✅ Ảnh đã tải xong (2000x1000)");
    }).catch(err => {
      console.error("❌ Lỗi khi chụp ảnh bằng html2canvas:", err);
    });
  });
};